
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@mui/joy';
import CustomSelectDropdown from '../../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import ActionButton from '../../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import { get_available_engineers } from '../../../../../config/ReportApis/employeeReportApis';
import { get_workforce_with_pagination } from '../../../../../config/Resource/workforceApis';


function AddEngineerModal({ handleSave, isButtonDisabled, defaultValues, scheduleID, isDisabled, IsUrgentSchedule }) {
    const [workforceListing, setWorkforceListing] = useState([]);


    // FETCH fetchWorkforce (supervisors and fses based on urgent schedule)
    const fetchWorkforce = async () => {
        try {
            let params = {};
            let response;

            if (IsUrgentSchedule) {
                // When urgent → get all supervisors and fses (RoleID: 5 &RoleID: 2) 5 = fse's ,2 means superviosr
                params = {
                    userRoles: `5,2`,
                    status: isDisabled ? '' : 1,
                };
                response = await get_workforce_with_pagination(params);
            } else {
                // When not urgent → get available engineers by date
                params = {
                    start_date: defaultValues?.SD_Survey_from_date,
                    end_date: defaultValues?.SD_Survey_end_date,
                    status: isDisabled ? '' : 1,
                    schedule_id: scheduleID ? scheduleID : ''
                };
                response = await get_available_engineers(params);
            }

            if (response?.status === "success") {

                const responseData = IsUrgentSchedule ? response?.data?.data : response?.data
                const transformedData = responseData?.map(item => ({
                    label: IsUrgentSchedule ? item?.UD_name : item?.EngineerName,
                    value: IsUrgentSchedule ? item?.UD_ID : item?.id,
                }));

                setWorkforceListing(transformedData || []);
            } else {
                setWorkforceListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setWorkforceListing([]);
        }
    };

    const formik = useFormik({
        initialValues: {
            engineerIDs: [],
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            engineerIDs: Yup.array().min(1, 'At least one employee is required'),
        }),
        // enableReinitialize: true,
        onSubmit: (values) => {
            // handleSave(values, id);
            handleSave(values, 'Add');

        },
    });

    const handleReset = () => {
        formik.setValues({
            engineerIDs: [],
        });
        formik.setTouched({
            engineerIDs: false,
        });
    };

    useEffect(() => {
        if (defaultValues) {
            fetchWorkforce()
        }

    }, [defaultValues])
    return (
        <div className='update-status-form-container'>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <div className='update-status-form-mid-container'>
                        <div className='update-status-label-container'>
                            <span className='update-status-label'>
                                Engineer <span className='update-status-required-remark'>*</span>
                            </span>
                        </div>
                        <CustomSelectDropdown
                            name="engineerIDs"
                            placeholder="Select Engineers"
                            options={workforceListing}
                            value={workforceListing?.filter(option => formik.values.engineerIDs?.includes(option.value))}
                            onChange={(selectedOptions) => {
                                // Map selected options to extract only the `value` (ID) field
                                const selectedValues = selectedOptions.map(option => option.value);
                                // Set the field value with the array of selected IDs
                                formik.setFieldValue("engineerIDs", selectedValues);
                            }}
                            onBlur={formik.handleBlur}
                            error={formik.touched.engineerIDs && Boolean(formik.errors.engineerIDs)}
                            helperText={formik.touched.engineerIDs && formik.errors.engineerIDs}
                            isDisabled={isDisabled}

                            isMulti={true} // Set to true for multi-select
                            width="100%"
                        />
                    </div>

                </Grid>
            </Grid>

            <div className='update-status-form-bottom-action-buttons-container'>
                <ActionButton onClick={handleReset} label='Reset' btnType='outlined' />
                <ActionButton onClick={formik.handleSubmit} btnDisable={isButtonDisabled} label='Save' btnType='primary' />
            </div>
        </div>
    );
}

export default AddEngineerModal;
